import { CSVLink } from 'react-csv';
import { useNavigate } from "react-router-dom";
import { Stack, StackItem } from "@fluentui/react";
import type { TextareaProps } from "@fluentui/react-components";
import { useState, useEffect, useContext, useCallback } from "react";
import { Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, Popover, PopoverTrigger, Field, ProgressBar, Textarea, Image, Input, Tooltip, Label, Link } from "@fluentui/react-components";
import { Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, AddSquare20Regular, Dismiss16Regular, Open20Regular, Delete20Regular, FilterAdd20Filled, Settings20Regular, Info16Filled } from "@fluentui/react-icons";
import { usePermissionStore } from "../../../Store/permissionStore";
import { Groups_func } from "../../../api/devices/groups/groups_func";
import FileUploadComponent from "../../../components/fileImport/file.import.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import DialogBox from "../../../components/dialog/dialog.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { DevicesPages } from "../../../components/side_menu/InlineSidenav";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { FileDownloadComponent } from "../../../components/fileExport/file.export.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { primaryIcon, secondaryIcon, dividerStyle, buttonContent, overlayLeftWidth, overlayRightWidth, DynamicBoxingCSS, SubSectionResponsive, parentHome, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { convertToExcelFormat, convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";

interface iChange {
  target: {
    value: any;
    name: any;
  };
};

export const Groups = () => {
  const [loading, setLoading] = useState(true);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [isOverResetDisabled, setOverResetDisabled] = useState(true);
  const [classificationNameValidation, setClassificationNameValidation] = useState(true);
  const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
  const [deleteClassification, setDeleteClassification] = useState(false);
  const [configGroupBtnCliked, setConfigGroupBtnCliked] = useState(false);
  const [addClassification, setAddClassification] = useState(false);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [isOverlayFilter, setIsOverlayFilter] = useState(false);
  const [overlayOpenNew, setOverlayOpenNew] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [refreshToast, setRefreshToast] = useState(false);
  const [isIconEnabled, setIconEnabled] = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [errorToast, setErrorToast] = useState(false);
  const [isRefresh, setRefresh] = useState(false);
  const [isfilter, setIsFilter] = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [final_data, set_final_data] = useState(null);
  const [devicesData, setDevicesData] = useState(null);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [devicesTableData, setDevicesTableData] = useState([]);
  const [exportDetails, setExportDetails] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [toastMessage, setToastMessage] = useState('');
  const [searchVal, setSearchVal] = useState("");
  const [validationText, setValidationText] = useState("");
  const [deviceSearchVal, setDeviceSearchVal] = useState("");
  const [groupConfigCnt, setGroupConfigCnt] = useState(0);
  const [selectedValue, setSelectedValue] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [overlayFilterArray, setOverlayFilterArray] = useState<string[]>([]);
  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
  const [classificationName, setClassificationName] = useState<any>('');
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
  const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
  const [overLayDataNew, setOverLayDataNew] = useState<any>({});
  const [linkedDeviceCnt, setLinkedDeviceCnt] = useState<any>({});
  const [csvDevicesList, setCsvDevicesList] = useState<any>([]);
  const [devicesOfTenant, setDevicesOfTenant] = useState<any>(null);
  const [operationType, setOperationType] = useState<any>({});
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [configureName, setConfiguredName] = useState([]);
  const [isConfigured, checkConfigured] = useState([]);
  const [uniqueOS, setUniqueOS] = useState([]);
  const [isOsName, setOsName] = useState([]);
  const [isCreatedBy, setCreatedBy] = useState<any[]>([]);
  const [isModalIconEnabled, setModalIconEnabled] = useState(false);
  const [isSubTableSelect, setIsSubTableSelect] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [csvFile, setCsvFile] = useState(null);

  const { permissions } = usePermissionStore();

  const permits = (permissions.includes("deviceClassification_ReadandExport"));
  const permitPrimary = (permissions.includes("deviceClassification_Read") || permits);
  const permitSecondary = (permissions.includes("all") || permissions.includes("deviceClassification_Fullaccess"));

  const navigate = useNavigate();
  const handle = useFullScreenHandle();
  const contextValue = useContext(GlobalContext);
  const { tenantName } = contextValue;

  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  console.log("Checking dropDownValue1: ", dropDownValue1);

  useEffect(() => {
    const createdByOptions = uniqueCreatedBy.map((item) => ({ key: item, label: <Caption1> {item} </Caption1> }));
    setCreatedBy(createdByOptions);
    console.log("Created by options: ", createdByOptions);
  }, [uniqueCreatedBy]);

  useEffect(() => {
    (filterArray.length > 0) ? setResetDisabled(false) : setResetDisabled(true);
  }, [filterArray]);

  useEffect(() => {
    (overlayFilterArray.length > 0) ? setOverResetDisabled(false) : setOverResetDisabled(true);
  }, [overlayFilterArray]);

  useEffect(() => {
    setConfiguredName(isConfigured.map((item) => ({ key: item, label: <Caption1> {item} </Caption1> }))); // configurationgroupName
  }, [isConfigured]);

  useEffect(() => {
    var tableColumns: any[] = [];
    var filterColumns: any[] = [];
    contextValue?.tableColumnsData?.Devices?.Device_Classification.forEach((val) => {
      const { display, priority, key, name } = val;
      const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
      if (display.table.toLocaleLowerCase() === "yes" && priority >= 0) {
        if (key === "created_on_timezoned" || key === "last_modified_timezoned") {
          tableColumns[priority] = ({
            key: key,
            label: (
              <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                <StackItem> <Body1Strong> {name} </Body1Strong> </StackItem>
                <StackItem align="center">
                  <Tooltip withArrow content={`Timezone: ${formattedTimeZone}`} relationship="description" positioning="above">
                    <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                  </Tooltip>
                </StackItem>
              </Stack>
            )
          });
        } else { tableColumns[priority] = ({ key: key, label: <Body1Strong> {name} </Body1Strong> }) };
      };
      if (display.filter.toLocaleLowerCase() === "yes") { filterColumns.push({ key: key, label: <Caption1> {name} </Caption1> }) };
    });
    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);
    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Devices?.Device_Classification.filter((val) => val.priority >= 0));
    contextValue.setManageViewPageDetails({ module: "Devices", page: "Device_Classification" });
  }, [contextValue.tableColumnsData]);

  useEffect(() => {
    var tempExportData = [];
    console.log("Checking exportDetails: ", exportDetails);
    exportDetails?.length > 0 && exportDetails.map((val) => {
      const { classificationName: name, createdBy, createdOn, lastModified, classificationName, isGroupConfigured } = val;
      tempExportData.push({
        "Classification Name": name,
        'Created By': createdBy,
        "Created On": createdOn != null ? convertToExcelFormat(createdOn) : '-',
        'Last Modified': lastModified != null ? convertToExcelFormat(lastModified) : '-',
        'Linked Devices': linkedDeviceCnt[classificationName],
        'Configuration Group': isGroupConfigured
      });
    });
    setExportData(tempExportData);
  }, [exportDetails, linkedDeviceCnt]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    dropDownValue1 === "Choose devices manually" && setSelectedValue(1);
    dropDownValue1 === "Upload a CSV containing the Devices" && setSelectedValue(2);
  }, [dropDownValue1]);

  /*
    useEffect(() => {
      // Roles and permissions
      async function loadRoute() {
        console.log("Role: ", sessionStorage.getItem('role'))
        const role = sessionStorage.getItem('role');
        try {
          const [routeAllowed, permissions] = await shouldLoadRoute(role);
          return (routeAllowed)
            ? (console.log("Permission: ", permissions), setPermissions(permissions))
            : console.log('Route is not allowed...');
        } catch (error) {
          console.error('Error loading route: ', error);
        }
      }
      loadRoute();
    }, []);
  */

  useEffect(() => {
    const operatingSystemName: any = uniqueOS.map((item) => {
      console.log("Items: ", item);
      return { key: item, label: <Caption1> {item} </Caption1> };
    });
    setOsName(operatingSystemName);
    console.table("Checking operatingSystemName test: ", operatingSystemName);
  }, [uniqueOS])

  useEffect(() => {
    console.log("Checking final_data: ", devicesData);
    devicesData !== undefined && devicesData !== null
      ? devicesData?.map((val, i) => {
        const newUniqueOs = [];
        devicesData?.forEach((val: { os: string; }) => {
          const { os } = val;
          if (os && os.trim() !== "-" && !newUniqueOs.includes(os)) { newUniqueOs.push(os) };
        });
        setUniqueOS(newUniqueOs);
        console.log("Unique operating System: ", newUniqueOs);
      }) : setUniqueOS([]);
  }, [devicesData])

  useEffect(() => {
    final_data !== undefined && final_data !== null
      ? final_data?.map((val, i) => {
        const configurenName = [];
        final_data?.forEach((val: { isGroupConfigured: any }) => {
          const { isGroupConfigured } = val;
          if (configurenName.indexOf(isGroupConfigured) === -1) { configurenName.push(isGroupConfigured) };
        });
        checkConfigured(configurenName);
        console.log("Unique operating System: ", configurenName);
      }) : (checkConfigured([]))
  }, [final_data]);

  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const newUniqueCreatedBy: string[] = [];
      final_data?.forEach((val: { createdBy: string; }) => {
        const { createdBy, } = val;
        if (createdBy && createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(createdBy)) { newUniqueCreatedBy.push(createdBy) };
      });
      setUniqueCreatedBy(newUniqueCreatedBy);
      console.log("Unique Created By: ", newUniqueCreatedBy);
    } else { setUniqueCreatedBy([]) };
  }, [final_data]);

  useEffect(() => {
    var tempTableData = [];
    var typeObj = {};
    // Roles and permissions
    // Data table values append code starts here
    console.log("Checking final_data: ", final_data);
    !isOverlayFilter && final_data !== undefined && final_data !== null ?
      final_data?.map((val, i) => {
        const { classificationName, type, id, createdBy, createdOn, lastModified, isGroupConfigured } = val;
        typeObj[classificationName] = type;
        const commonData = {
          id: [id, classificationName],
          classification_name: {
            id: i,
            label: (
              <Button style={buttonContent} size="small" appearance="transparent" onClick={() => {
                navigate("/manage/devices/device_classification/devices");
                localStorage.setItem('classificationName', classificationName);
                contextValue.setSelectedRowDetails({ ...contextValue.selectedRowDetails, name: classificationName });
              }}>
                {classificationName}
              </Button>
            )
          },
          created_by: { label: <Caption1 onClick={handleClick}> {createdBy} </Caption1>, status: "" },
          created_on: { label: <Caption1> {convertUTCToReadableFormat(createdOn)} </Caption1> },
          created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(createdOn, userTimeZone)} </Caption1> },
          last_modified: {
            label: <Caption1> {lastModified ? convertUTCToReadableFormat(lastModified) : '-'} </Caption1>
          },
          last_modified_timezoned: {
            label: <Caption1> {lastModified ? convertToLocalTimezone(lastModified, userTimeZone) : '-'} </Caption1>
          },
          linked_devices: { label: <Caption1> {linkedDeviceCnt[classificationName]} </Caption1> },
          config_group: { label: <Caption1> {isGroupConfigured} </Caption1> }
        };
        if (permitPrimary) { tempTableData.push({ ...commonData, checkbox: 'hide' }); }
        else if (permitSecondary) { tempTableData.push({ ...commonData, checkbox: isGroupConfigured === 'Yes' ? 'hide' : 'show' }); }
      }) : (tempTableData = []);
    setOperationType(typeObj);
    // tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
    !isOverlayFilter && (tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]));
    setTimeout(() => {
      !isOverlayFilter && final_data !== undefined && final_data !== null && setLoading(false);
      if (isRefresh) {
        setRefreshToast(true);
        setTimeout(() => {
          setRefresh(false);
          setRefreshToast(false);
        }, 3000);
      }
    }, 500);
  }, [final_data, linkedDeviceCnt, permissions]);
  console.log("Checking isOverlayFilter: ", isOverlayFilter);

  useEffect(() => {
    var tempTableData1 = [];
    console.log("Checking final_data: ", devicesData);
    devicesData !== undefined && devicesData !== null ?
      devicesData?.map((val: any, i: any) => {
        const { host, os } = val;
        tempTableData1.push({
          id: host,
          device_name: { label: <Caption1> {host} </Caption1>, id: i },
          os: { label: <Caption1> {os} </Caption1>, status: "" },
        });
      })
      : (tempTableData1 = []);
    tempTableData1.length > 0 ? setDevicesTableData(tempTableData1) : setDevicesTableData([]);
  }, [devicesData]);

  useEffect(() => {
    const extraForm = (
      <>
        {(contextValue.selectedRowIdInSubTable.length > 0 || selectedTableData.length > 0) && <Divider vertical />}
        <StackItem>
          <StackItem>
            {(contextValue.selectedRowIdInSubTable.length > 0 || selectedTableData.length > 0) && <DataTable tableData={selectedTableData} columns={[{ key: "selected", label: <Body1Strong> Selected ({contextValue.selectedRowIdInSubTable.length}) </Body1Strong> }]} />}
          </StackItem>
          <Stack tokens={{ childrenGap: 10 }} horizontalAlign="center">
            <Label> <Body1Strong> Selected </Body1Strong> </Label>
            {(contextValue.selectedRowIdInSubTable.length > 0 || selectedTableData.length > 0) && selectedTableData.map((val: any) => <StackItem> <Text> {val} </Text> </StackItem>)}
          </Stack>
        </StackItem>
      </>
    );

    const overlayHeader = () => <Title3> {selectedValue == 0 ? 'Create Classification' : 'Create Devices'} </Title3>;

    const overlayBody = () => {
      const asterix = <Image src="/Dashboard/image/required.svg" />;
      const filterFunction = () => {
        const handleCloseOverlayFilter = (index: any) => {
          console.log("Checking handleCloseOverlayFilter clicked...");
          setOverlayFilterArray(overlayFilterArray.filter((x, itemIndex) => itemIndex !== index)); // updatedArray
          // setLoadingTable(true);
          setIsOverlayFilter(false);
        };

        const menuDropdownDataSecondary = () => {
          const handleFilter = () => { setFilterMenuOpenOverlay(true) };

          const handleApply = () => {
            const result = dropDownValue1Overlay + " : " + dropDownValue2Overlay;
            setOverlayFilterArray([...overlayFilterArray, result])
            // setIsFilter(true);
            setIsOverlayFilter(true);
            // setLoading(true);
            setDropDownValue1Overlay('');
            setDropDownValue2Overlay('');
            setFilterMenuOpenOverlay(false)
          };

          const handleCancel = () => {
            setFilterMenuOpenOverlay(false);
            setIsOverlayFilter(false);
            setDropDownValue1Overlay('');
            setDropDownValue2Overlay('');
          };

          const disableApply = (!dropDownValue1Overlay || !dropDownValue2Overlay || overlayFilterArray.includes(`${dropDownValue1Overlay}:`));

          const menuButton = (
            <MenuButton disabled={loading} shape="circular" size="small" onClick={handleFilter}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <FilterAdd20Filled {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
                <StackItem> <Caption1> Filter </Caption1> </StackItem>
              </Stack>
            </MenuButton>
          );

          const menuItemVal = (
            <>
              <Body1Strong> Add a Filter </Body1Strong>
              <Divider />
              <MenuList>
                <Stack tokens={{ childrenGap: 5 }}>
                  {empty}
                  <StackItem> <Caption1> Filter </Caption1> </StackItem>
                  <DropdownComponent optionData={overlayColumns} setDropDownValue={setDropDownValue1Overlay} dropDownvalue={dropDownValue1Overlay} />
                  <StackItem> <Divider /> </StackItem>
                  <StackItem> <Caption1> Value </Caption1> </StackItem>
                  {
                    dropDownValue1Overlay === "Operating System" &&
                    <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2Overlay} dropDownvalue={dropDownValue2Overlay} />
                  }
                  {
                    dropDownValue1Overlay === "Device Name" &&
                    <Input size='small' onChange={overlayInputChange} name="filter" value={dropDownValue2Overlay} />
                  }
                  <StackItem> <Divider /> </StackItem>
                  <Stack tokens={{ childrenGap: 10 }} horizontal>
                    <Button shape="circular" appearance="primary" onClick={handleApply} disabled={disableApply}> <Caption1> Apply </Caption1> </Button>
                    <Button shape="circular" onClick={handleCancel}> <Caption1> Cancel </Caption1> </Button>
                  </Stack>
                </Stack>
              </MenuList>
            </>
          );

          return <StackItem> <MenuDropdown open={filterMenuOpenOverlay} btn={menuButton} itemVal={menuItemVal} /> </StackItem>;
        };

        return selectedValue == 1 &&
          <Stack tokens={{ childrenGap: 30 }} horizontal>
            <StackItem>
              <Stack tokens={{ childrenGap: 10 }}>
                <InfoBar title="Try changing or adding filters if you don't see what you're looking for." />
                <Stack wrap horizontal tokens={{ childrenGap: 20 }}>
                  {empty}
                  <SearchBar columnSearch="for Device Name" searchVal={deviceSearchVal} setSearchVal={setDeviceSearchVal} disabled={loading} />
                  {menuDropdownDataSecondary()}
                  <StackItem onClick={() => { setOverlayFilterArray([]); setIsFilter(false); setDropDownValue2(''); setOverResetDisabled(true); }}>
                    <Button shape="circular" appearance="subtle" size="small" disabled={isOverResetDisabled}>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                      </Stack>
                    </Button>
                  </StackItem>
                  <StackItem>
                    {overlayFilterArray.length > 0 && overlayFilterArray.map((item, index) => (
                      <Button shape="circular" size="small">
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                          {item}
                          <Dismiss16Regular onClick={() => { handleCloseOverlayFilter(index) }} />
                        </Stack>
                      </Button>
                    ))}
                  </StackItem>
                </Stack>
                <Stack tokens={{ childrenGap: 10 }}>
                  <FluentProvider theme={dashboardTheme}>
                    {devicesTableData.length > 0 ? <DataTable tableData={devicesTableData} columns={overlayColumns} isSubTable={true} /> : noResult()}
                  </FluentProvider>
                </Stack>
              </Stack>
            </StackItem>
            {/* extraform */}
          </Stack>
      };

      const overlayLeftData = () => (
        <StackItem grow shrink style={overlayLeftWidth}>
          <Stack tokens={{ childrenGap: 10 }} horizontalAlign="start">
            {empty}
            <Body1> Classification name{asterix} </Body1>
            <Field validationMessage={validationText}
              validationState={classificationNameValidation
                ? (validationText === "name available" ? "success" : "none")
                : (validationText === "name available" ? "none" : "warning")
              }>
              <Textarea size="small" placeholder="Classification name" className="classfication_textarea" disabled={selectedValue === 0 ? false : true} onChange={handleNameInput} /* value={classificationName} */ />
            </Field>
            {empty}
            <Body1> How you would like to add machines to this Device Classification?{asterix} </Body1>
            {dropdownData()}
            <StackItem>
              {filterFunction()}
              {selectedValue == 2 &&
                <Stack tokens={{ childrenGap: 10 }}>
                  {empty}
                  <Body1> Start by downloading a file with the list of devices from the tenant you want. <br /> You can choose devices from the same site or different ones to create groups. </Body1>
                  <Body1Strong> Steps to create the CSV group </Body1Strong>
                  <Stack horizontal>
                    <Body1> 1. Download the file that contains the list of devices. </Body1>
                    <FileDownloadComponent fileName="devices_list" data={`Machines\n ${devicesData.map((val: { host: any }) => val.host).join("\n")}`} />
                  </Stack>
                  <Stack horizontal>
                    <Body1> 2. Revise device grouping in the CSV. </Body1>
                    <Link>
                      <Button size="small" appearance="subtle" shape="circular" icon={<Open20Regular {...primaryIcon} />}>  Watch the instructional video for guidance </Button>
                    </Link>
                  </Stack>
                  <Stack horizontal>
                    <Body1> 3. Upload your .csv file. </Body1>
                    <FileUploadComponent setDeviceList={setCsvDevicesList} />
                  </Stack>
                  {devicesOfTenant != null && csvDevicesList.length > 0 && selectedTableData.length > 0 &&
                    <>
                      <Body1Strong> {selectedTableData.length} unique machine found. </Body1Strong>
                      <Text> <Body1Strong> Note: </Body1Strong> Kindly check the group names and confirm that everything is exactly the way you need them. If you have made any mistake, kindly make the changes and upload the CSV with the corrections. </Text>
                    </>
                  }
                  {devicesOfTenant != null && csvDevicesList.length > 0 && selectedTableData.length == 0 &&
                    <Body1Strong> No unique machine found </Body1Strong>}
                </Stack>
              }
            </StackItem>
          </Stack>
        </StackItem>
      );

      const overlayRightData = () => (
        selectedValue === 1 && (contextValue.selectedRowIdInSubTable.length >= 0 || selectedTableData.length >= 0) &&
        <StackItem grow shrink style={overlayRightWidth}>
          <DataTable size="small" tableData={selectedTableData} columns={[{
            key: "selected", label: (
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <Body1Strong> Selected ({contextValue.selectedRowIdInSubTable.length}) </Body1Strong>
                {empty}
                <Body1 onClick={() => contextValue.setSelectedRowIdInSubTable([])}> Reset </Body1>
              </Stack>
            )
          }]} />
        </StackItem>
      );

      return (
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          {overlayLeftData()}
          {selectedValue === 1 && <StackItem> <Stack horizontal style={dividerStyle} horizontalAlign="center"> <Divider vertical /> </Stack> </StackItem>}
          {overlayRightData()}
        </Stack>
      );
    };

    const overlayFooter = () => (
      <Button shape="circular" appearance="primary"
        disabled={(selectedTableData.length > 0 && classificationName.length > 0 && classificationNameValidation) ? false : true}
        onClick={() => (
          setAddClassification(true), selectedValue == 1 ? (setClassificationNameValidation(false), setDeviceSearchVal('')) : null
        )}
      > Submit </Button>
    );

    setOverLayDataNew({
      size: "large", isTabs: false, headerTitle: overlayHeader(), bodyData: overlayBody(), footerData: overlayFooter()
    });
  }, [devicesTableData, selectedValue, selectedTableData, classificationName, classificationNameValidation, csvDevicesList, filterMenuOpenOverlay, dropDownValue1Overlay, dropDownValue2Overlay, filterArray, overlayFilterArray, isfilter, isOverlayFilter, validationText]);

  useEffect(() => {
    var validDevicesList = [];
    var inValidDevicesList = [];
    var alldDevicesList = [];
    if (csvDevicesList.length > 0) {
      validDevicesList = [];
      inValidDevicesList = [];
      alldDevicesList = [];
      devicesOfTenant?.map((val: { host: any }) => { alldDevicesList.push(val.host); });
      csvDevicesList.map((val: string) => {
        var deviceName = val.replace(/[\r\n]/g, '');
        alldDevicesList.includes(deviceName) ? validDevicesList.push(deviceName) : inValidDevicesList.push(deviceName);
      });
      validDevicesList.length > 0 ? setSelectedTableData(validDevicesList) : setSelectedTableData([]);
      contextValue.setSelectedRowIdInSubTable(validDevicesList);
    }
  }, [devicesOfTenant, csvDevicesList]);

  useEffect(() => {
    !overlayOpen && setSelectedValue(0);
    !overlayOpen && setDeviceSearchVal('');
    console.log("Overlay closed. Resetting selectedValue to 0...");
  }, [overlayOpen]);

  useEffect(() => {
    !overlayOpenNew && setSelectedValue(0); /*setFilterArray([]); */
    !overlayOpenNew && setDeviceSearchVal('');
  }, [overlayOpenNew]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
    contextValue.setSelectedRowIdInSubTable([]);
  }, []);

  useEffect(() => {
    var dataArr = [];
    contextValue.selectedRowIdInSubTable.map((val, i) => {
      dataArr.push({ id: i, checkbox: "hide", selected: { label: <Caption1> {val} </Caption1>, id: i } });
    });
    dataArr.length > 0 ? setSelectedTableData(dataArr) : setSelectedTableData([]);
    contextValue.selectedRowIdInTable.length > 0 ? setIconEnabled(true) : setIconEnabled(false);
  }, [contextValue.selectedRowIdInTable, contextValue.selectedRowIdInSubTable]);

  useEffect(() => {
    const { selectedRowIdInTable, selectedRowIdInSubTable, setSelectedRowIdInSubTable, setSelectedRowIdInTable } = contextValue;
    const pageNo = (currentPageNo - 1) * 50;
    const props = {
      data: final_data, func: set_final_data, setDeleteEnabled: setIconEnabled, searchVal, pageNo, setTotalPages, setTotalRecords, isfilter, dropDownValue1, setIsFilter, dropDownValue2, filterArray, overlayFilterArray, linkedDeviceCnt, setLinkedDeviceCnt, setRefreshToast, setRefresh, isRefresh, classificationName, addClassification, deviceSearchVal, isOverlayFilter, configGroupBtnCliked, csvDevicesList, deleteClassification, setDevicesOfTenant, setDeleteClassification, setClassificationNameValidation, setOverlayOpenNew, setAddClassification, selectedValue, setGroupConfigCnt, setIsToast, setToastMessage, setErrorToast, setConfigGroupBtnCliked, operationType, setDevicesData, setExportDetails, setExportBtnClicked, tenant: tenantName, exportBtnClicked, devicesOfTenant, devicesData, overlayOpenNew, setValidationText, selectedRowIdInTable, selectedRowIdInSubTable, setSelectedRowIdInTable, setSelectedRowIdInSubTable
    };
    if (!configGroupBtnCliked || configGroupBtnCliked || addClassification) { Groups_func(props) };
  }, [deleteClassification, currentPageNo, searchVal, isRefresh, deviceSearchVal, configGroupBtnCliked, addClassification, csvDevicesList, isfilter, filterArray, overlayFilterArray, exportBtnClicked, classificationName, isOverlayFilter]);

  const handleClick = () => {
    // const { trackEvent } = useTracking();
    const eventData = { action: 'click' };
    console.log('Event Data: ', eventData);
    // trackEvent(eventData); // Log the event data to the console
  };

  const alpha = /^[A-Za-z ]*$/;
  const alphaNumeric = /^[A-Za-z0-9_-]*$/;
  const numeric = /^[0-9]*$/;

  const inputChange = (e: iChange) => {
    const { value, name } = e.target;
    console.log("Entered value: ", value);
    const validationRules = { "Classification Name": alphaNumeric, "Configuration Group": alpha, "Linked Devices": numeric };
    if (name === "filter" && validationRules[dropDownValue1]?.test(value)) { setDropDownValue2(value) };
  };

  const overlayInputChange = (e: iChange) => {
    const { value, name } = e.target;
    console.log("Entered value: ", value);
    if (name === "filter" && dropDownValue1Overlay === "Device Name" && alphaNumeric.test(value)) { setDropDownValue2Overlay(value) };
  };

  const handleNameInput = useCallback<TextareaProps["onChange"]>((ev, data) => {
    let debounceTimeout: ReturnType<typeof setTimeout>;
    var inputVal = data.value;
    // (/^(?! )[ a-zA-Z0-9_]*$/.test(inputVal)) ?
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => { setClassificationName(inputVal) }, 800);
    //  : null;
  }, []);

  const overlayColumns = [
    { key: "device_name", label: <Body1Strong> Device Name </Body1Strong> },
    { key: "os", label: <Body1Strong> Operating System  </Body1Strong> }
  ];

  const empty = <StackItem><Text /></StackItem>;

  const noResult = () => (
    <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}>
      <StackItem> <Text size={500}> No result. </Text> </StackItem>
    </Stack>
  );

  const breadcrumbsData = () => (
    <StackItem grow shrink style={BreadcrumbsBorder}>
      <Stack tokens={{ childrenGap: 10 }} horizontal>
        <StackItem grow shrink>
          <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
            {empty}
            <StackItem grow shrink>
              <Breadcrumbs items={[
                { name: "Manage", link: "/home" },
                { name: "Devices", link: "/manage/devices/overview" },
                { name: "Device Classification", link: "#" }
              ]} />
            </StackItem>
          </Stack>
        </StackItem>
      </Stack>
    </StackItem>
  );

  const searchBarData = () => (
    <StackItem>
      <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch="for Classification" searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading} />
    </StackItem>
  );

  const overflowContent = () => {
    const handleAdd = () => {
      setSelectedTableData([]);
      setOverlayOpenNew(true);
      setSelectedValue(0);
      contextValue.setSelectedRowIdInSubTable([]);
      setDevicesOfTenant(null);
      setCsvDevicesList([]);
      setClassificationName('');
      setClassificationNameValidation(true);
      setValidationText('');
    };

    const handleRefresh = () => {
      setCurrentPageNo(1);
      setRefresh(true);
      setLoading(true);
    };

    const handleExport = () => { setExportBtnClicked(true); };

    const hanldeManage = () => { document.getElementById("manageView").click() };

    const handleConfirmPrimary = () => {
      setOverlayOpen(true);
      setConfigGroupBtnCliked(true);
      setShowMessage(false);
    };

    const handleConfirmSecondary = () => { setDeleteClassification(true); };

    const overFlowContent = {
      data:
        <>
          <StackItem>
            {permitSecondary
              ? (
                <Button shape="circular" size="small" appearance="subtle" disabled={loading} onClick={handleAdd}>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <AddSquare20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
                    <StackItem> <Caption1> Create Classification </Caption1> </StackItem>
                  </Stack>
                </Button>
              )
              : (
                <Tooltip withArrow content="You do not have access" relationship="description" positioning="above">
                  <Button shape="circular" appearance="subtle" size="small" disabled>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem> <Caption1> Create Classification </Caption1> </StackItem>
                    </Stack>
                  </Button>
                </Tooltip>
              )
            }
          </StackItem>
          <StackItem> <Divider vertical /> </StackItem>
          <StackItem>
            <DialogBox
              content="Are you sure you want to create a configuration group for the selected device classification?"
              headerButton={
                <Button shape="circular" size="small" appearance="subtle" disabled={isIconEnabled ? false : true}>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <AddSquare20Regular {...(isIconEnabled ? primaryIcon : secondaryIcon)} /> </StackItem>
                    <StackItem> <Caption1> Create Configuration Group </Caption1> </StackItem>
                  </Stack>
                </Button>
              }
              footer={
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                  <StackItem>
                    <Button shape="circular" size="small" appearance="primary" onClick={handleConfirmPrimary}> Confirm </Button>
                  </StackItem>
                  <StackItem> <Button shape="circular" size="small"> Cancel </Button> </StackItem>
                </Stack>
              }
            />
          </StackItem>
          <StackItem> <Divider vertical /> </StackItem>
          <StackItem>
            <DialogBox
              content="Kindly verify your intent to delete the classification."
              headerButton={
                <Button shape="circular" size="small" appearance="subtle" disabled={isIconEnabled ? false : true}>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <Delete20Regular {...(isIconEnabled ? primaryIcon : secondaryIcon)} /> </StackItem>
                    <StackItem> <Caption1> Delete </Caption1> </StackItem>
                  </Stack>
                </Button>
              }
              footer={
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                  <StackItem>
                    <Button shape="circular" appearance="primary" size="small" onClick={handleConfirmSecondary}> Confirm </Button>
                  </StackItem>
                  <StackItem> <Button shape="circular" size="small"> Cancel </Button> </StackItem>
                </Stack>
              }
            />
          </StackItem>
          <StackItem> <Divider vertical /> </StackItem>
          <StackItem>
            <Button shape="circular" size="small" appearance="subtle" disabled={loading} onClick={handleRefresh}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <ArrowClockwise20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
                <StackItem> <Caption1> Refresh </Caption1> </StackItem>
              </Stack>
            </Button>
            {(permitSecondary || permits) ?
              <>
                <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_DeviceClassifications.csv`} />
                <Button shape="circular" disabled={loading} size="small" appearance="subtle" onClick={handleExport}>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <ArrowDownload20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                  </Stack>
                </Button>
              </>
              :
              <Tooltip withArrow content="You do not have access" relationship="description" positioning="above">
                <Button shape="circular" appearance="subtle" size="small" disabled>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                  </Stack>
                </Button>
              </Tooltip>
            }
            <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={hanldeManage}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <Settings20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
                <StackItem> <Caption1> Manage View </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
          <StackItem grow shrink>
            <Stack horizontalAlign="end"> <StackItem grow shrink> <FullScreenButton handle={handle} /> </StackItem> </Stack>
          </StackItem>
        </>
    };
    return (
      <StackItem>
        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowContent} />
        <Divider />
      </StackItem>
    )
  };

  const menuDropdownDataPrimary = () => {
    const handleFilter = () => { setFilterMenuOpen(true) };

    const handleApply = () => {
      const result = dropDownValue1 + " : " + dropDownValue2;
      setFilterArray([...filterArray, result])
      setIsFilter(true);
      setDropDownValue1('');
      setDropDownValue2('');
      setFilterMenuOpen(false);
    };

    const handleCancel = () => {
      setFilterMenuOpen(false);
      setDropDownValue1('');
      setDropDownValue2('');
    };
    const handleFilterNew = (newValue: any) => {
      setDropDownValue1(newValue);
      setDropDownValue2('');
    };

    const disableApply = (!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`)));

    const menuButton = (
      <MenuButton disabled={loading} shape="circular" size="small" onClick={handleFilter}>
        <Stack tokens={{ childrenGap: 5 }} horizontal>
          <StackItem> <Filter20Filled {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
          <StackItem> <Caption1> Filter </Caption1> </StackItem>
        </Stack>
      </MenuButton>
    );

    const menuItemVal = (
      <>
        <Body1Strong> Add a Filter </Body1Strong>
        <Divider />
        <MenuList>
          <Stack tokens={{ childrenGap: 5 }}>
            {empty}
            <StackItem> <Caption1> Filter </Caption1> </StackItem>
            <DropdownComponent optionData={filterColumnsData} setDropDownValue={handleFilterNew} dropDownvalue={dropDownValue1} />
            <StackItem> <Divider /> </StackItem>
            <StackItem> <Caption1> Value </Caption1> </StackItem>
            {
              (dropDownValue1 === 'Created On' || dropDownValue1 === 'Last Modified') &&
              <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />
            }
            {
              (dropDownValue1 === "Classification Name") && /*(dropDownValue1 === "Created By") */
              <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />
            }
            {
              dropDownValue1 === "Created By" &&
              (
                filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`))
                  ? <span style={{ color: 'red' }}> This column is already filtered </span>
                  : <DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />
              )
            }
            {
              dropDownValue1 === "Configuration Group" &&
              <DropdownComponent optionData={configureName} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />
            }
            <StackItem> <Divider /> </StackItem>
            <Stack tokens={{ childrenGap: 10 }} horizontal>
              <Button shape="circular" appearance="primary" onClick={handleApply} disabled={disableApply}>
                <Caption1> Apply </Caption1>
              </Button>
              <Button shape="circular" onClick={handleCancel}> <Caption1> Cancel </Caption1> </Button>
            </Stack>
          </Stack>
        </MenuList>
      </>
    );

    return <StackItem> <MenuDropdown open={filterMenuOpen} btn={menuButton} itemVal={menuItemVal} /> </StackItem>;
  };

  const resetFilters = () => (
    <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
      <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
        <Stack tokens={{ childrenGap: 5 }} horizontal>
          <StackItem> <FilterDismiss20Filled {...(isResetDisabled ? secondaryIcon : primaryIcon)} /> </StackItem>
          <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
        </Stack>
      </Button>
    </StackItem>
  );

  const handleCloseFilter = (index: any) => {
    console.log("Clicked...");
    setFilterArray(filterArray.filter((x, itemIndex) => itemIndex !== index)); // updatedArray
    !isOverlayFilter && setLoading(true)
  };

  const tagsData = () => (
    <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
      <StackItem>
        {filterArray.length > 0 &&
          <Stack horizontal wrap>
            {filterArray.map((item, index) => (
              <Button shape="circular" size="small">
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  {item.includes("00:00") ? item.split("00:00")[0].trim() : item}
                  <Dismiss16Regular onClick={() => { handleCloseFilter(index) }} />
                </Stack>
              </Button>
            ))}
          </Stack>}
      </StackItem>
      <StackItem disableShrink>
        {(tableData.length > 0 && !loading) && totalRecords > 0 &&
          <Caption1>
            Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
          </Caption1>
        }
      </StackItem>
    </Stack>
  );

  const toastsData = () => (
    <>
      {
        isToast &&
        <ToastComponent footer="" toastIntent="success" position="top-end" title="Success" setmessagebar={setIsToast} isToastEnabled={isToast} message={addClassification ? "New Classification Created Successfully" : "Classification Deleted Successfully"} />
      }
      {
        refreshToast &&
        <ToastComponent footer="" toastIntent="success" position="top-end" title="Success" setmessagebar={setIsToast} isToastEnabled={refreshToast} message="Data Table Refreshed" />
      }
      {
        errorToast &&
        <ToastComponent footer="" toastIntent="error" position="top-end" title="Failed" setmessagebar={setErrorToast} message={toastMessage} />
      }
    </>
  );

  const dropdownData = () => {
    const handleManual = () => {
      setSelectedValue(1);
      setIsSubTableSelect(true);
      setCsvFile(null);
      contextValue.selectedRowIdInTable.length > 0 && contextValue.setSelectedRowIdInTable([]);
    };

    const handeCSV = () => {
      setSelectedValue(2);
      setSelectedTableData([]);
      contextValue.setSelectedRowIdInSubTable([]); // Clear selected devices
      setCsvFile(null);
    };

    const dropdownDatas = [
      { key: "op_1", label: <Body1Strong onClick={handleManual}> Choose devices manually </Body1Strong> },
      { key: "op_2", label: <Body1Strong onClick={handeCSV}> Upload a CSV containing the Devices </Body1Strong> }
    ];

    return <DropdownComponent optionData={dropdownDatas} setDropDownValue={setDropDownValue1} dropDownvalue={dropDownValue1} disabled={classificationName.length > 0 && classificationNameValidation ? false : true} />;
  };

  const overLayData = () => {
    const handleAcknowledge = () => {
      navigate("/manage/devices/device_classification");
      setOverlayOpen(false);
      contextValue.setSelectedRowIdInTable([]);
      setGroupConfigCnt(0);
      setConfigGroupBtnCliked(false);
      setRefresh(true);
    };

    const overlayContent = {
      size: "large",
      isTabs: false,
      headerTitle: <Title3> Creating Configuration Group </Title3>,
      bodyData: (
        <Stack tokens={{ childrenGap: 20 }}>
          {empty}
          <StackItem>
            {groupConfigCnt != contextValue.selectedRowIdInTable.length &&
              <Field validationState="none" validationMessage="Converting to a Configuration Group... Please wait...">
                <ProgressBar />
              </Field>}
            {groupConfigCnt}
            <Text> / </Text>
            {contextValue.selectedRowIdInTable.length}
            {groupConfigCnt == contextValue.selectedRowIdInTable.length &&
              <Field validationState="success" validationMessage={`${groupConfigCnt} configuration groups is created succesfully`}>
                <ProgressBar value={1} color="success" />
              </Field>
            }
          </StackItem>
        </Stack>
      ),
      footerData: isModalIconEnabled
        ? (
          <Popover trapFocus>
            <PopoverTrigger>
              <Button shape="circular" appearance="subtle" onClick={handleAcknowledge} disabled={(groupConfigCnt === contextValue.selectedRowIdInTable.length) ? false : true}>
                <StackItem> <Caption1> Acknowledge </Caption1> </StackItem>
              </Button>
            </PopoverTrigger>
            <Stack verticalAlign="end"> </Stack>
          </Popover>
        )
        : (
          <Button shape="circular" appearance="primary" onClick={handleAcknowledge} disabled={(groupConfigCnt == contextValue.selectedRowIdInTable.length) ? false : true}>
            <StackItem> <Caption1> Acknowledge </Caption1> </StackItem>
          </Button>
        )
    };
    return (
      <>
        <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overlayContent} />
        <OverLay overlayopen={overlayOpenNew} setOverlayOpen={setOverlayOpenNew} overlayData={overLayDataNew} />
      </>
    );
  };

  return (
    <FluentProvider style={DynamicBoxingCSS} theme={dashboardTheme}>
      <FullScreen className="fullScreenBackgroundColor" handle={handle}>
        {breadcrumbsData()}
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            <Stack tokens={{ childrenGap: 10 }} horizontal style={DynamicBoxingCSS}>
              <StackItem style={DynamicBoxingCSS}>
                <Stack style={DynamicBoxingCSS}>
                  <Stack tokens={{ childrenGap: 25 }} horizontal> {empty} </Stack>
                  <FluentProvider style={parentHome} theme={dashboardTheme}>
                    <Stack style={parentHome} horizontal>
                      <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={DevicesPages(`Device${" "}Classification`)} />
                      <StackItem style={DynamicBoxingCSS}>
                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                          {overflowContent()}
                          <StackItem>
                            <StackItem style={wraperStyle}>
                              <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                  {searchBarData()}
                                  {menuDropdownDataPrimary()}
                                  {resetFilters()}
                                </Stack>
                                {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                              </Stack>
                              {tagsData()}
                            </StackItem>
                          </StackItem>
                          {loading ? <SkeletonDataTable /> : tableData.length > 0 ? <DataTable tableData={tableData} columns={tableColumnsData} /> : noResult()}
                        </Stack>
                      </StackItem>
                    </Stack>
                  </FluentProvider>
                </Stack>
                {overLayData()}
                {toastsData()}
              </StackItem>
            </Stack>
          </StackItem>
          {empty}
        </Stack>
      </FullScreen>
    </FluentProvider>
  );
};
